module.exports = __webpack_public_path__ + "static/media/refresh_blue.2b642a3c.png";